import {
    useCallback,
} from 'react'
import Collapse from '@mui/material/Collapse'

import ContractBasisRequests from 'app/requests/ContractBasis/ContractBasis.requests'
import {
    useArchivedTableControl,
} from 'app/shared-components/TableControls/ShowArchived'
import LaneGroupsTable from 'app/Apps/Pricing/ContractBasis/components/LaneGroupsTable'
import StatusHandler from 'app/shared-components/StatusHandler'
import Card from 'app/shared-components/Card'
import useRenderTableControlPanel from 'app/shared-components/CollapsibleTable/useRenderTableControlPanel'
import LaneGroupForm from 'app/Apps/Pricing/LaneGroups/LaneGroupForm'
import useCollapsablePanel from 'app/shared-components/CollapsibleTable/hooks/useCollapsablePanel'

import usePricingRoutes from 'app/SkyNetRoutes/hooks/usePricingRoutes'
import useHasPermission from 'app/hooks/useHasPermission'

import useGetContractBasis from '../hooks/useGetContractBasis'

import useStyles from './LaneGroups.styles'

const LaneGroups = ({
    id: contractId,
}: { id: number }) => {
    const {
        LaneGroups: LaneGroupsRoutes,
    } = usePricingRoutes()
    const {
        classes,
    } = useStyles()
    const contractBasisCreate = useHasPermission(['contract_basis_create'])

    const {
        data,
        error,
        isDataReady,
        isError,
        isFetching,
    } = useGetContractBasis(contractId)

    const showArchived = useArchivedTableControl('LaneGroup')

    const {
        openCreateForm,
        createFormOpened,
        closeCreateForm,
    } = useCollapsablePanel(data?.currency)

    const renderTableControlPanel = useRenderTableControlPanel({
        title: 'Lane Groups',
        stateName: 'LaneGroup',
        createFormOpened,
        openCreateForm,
        closeCreateForm,
        createEnabled: contractBasisCreate,
    })

    const onRowClick = useCallback(({
        id,
    }) => {
        LaneGroupsRoutes.Overview.navigate({
            params: {
                key: id,
            },
            options: {
                state: {
                    filter: {
                        customerQuotationLocationName: [data?.customerQuotation?.locationName],
                        pricingAccountCompanyName: [data?.account?.company?.companyName],
                        contractBasisCurrency: [data?.currency],
                    },
                },
            },
        })
    }, [
        LaneGroupsRoutes.Overview,
        data,
    ])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <div
                data-testid="LaneGroupsTable"
                className={classes.root}
            >
                <Card
                    fullHeight
                    contentClass={classes.cardContent}
                    data-testid="LaneGroupsTable-card"
                >
                    <div className={classes.container}>
                        <Collapse in={createFormOpened}>
                            <LaneGroupForm
                                onSuccess={onRowClick}
                                onCancel={closeCreateForm}
                                requestParam={ContractBasisRequests.createLaneGroup({
                                    contractId,
                                })}
                            />
                        </Collapse>
                        <LaneGroupsTable
                            contractId={contractId}
                            onRowClick={onRowClick}
                            renderControlPanel={renderTableControlPanel}
                            showArchived={showArchived}
                        />
                    </div>
                </Card>
            </div>
        </StatusHandler>
    )
}

export default LaneGroups
